import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "survey-receive-options"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["id"]
const _hoisted_4 = {
  key: 1,
  class: "survey-receive-options--answer"
}

import { onMounted, ref, nextTick } from 'vue'
import {
    ConversationSpec,
    ReceiveOption,
    SurveyDisplayValues,
} from '@/entities/conversation'
import {
    initInlineWidget,
    hasCalendly,
    isCalendlyEvent,
} from '@/utils/calendly'

interface Props {
    item: ReceiveOption
    surveySpec: ConversationSpec
    surveyDisplayValues?: SurveyDisplayValues
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ConversationItemCalendly',
  props: {
    item: {},
    surveySpec: {},
    surveyDisplayValues: {}
  },
  emits: ['callNext'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const hasAnswer = ref(false)
const selectedAnswer = ref('')
const showCalendly = ref(false)
const calendlyFrameId = ref('')
const currentCalendlyFrame = ref<HTMLElement | null>(null)

const calendlyEventWindowSizes = {
    event_type_viewed: '970px',
    date_and_time_selected: '620px',
    event_scheduled: '490px',
}

onMounted(() => {
    if (
        props.surveyDisplayValues &&
        props.surveyDisplayValues[props.item?.param]
    ) {
        const selectedOptionsKey = props.surveyDisplayValues[props.item?.param]
        const selectedOption = props.item.options.find(
            (option) => option.key === selectedOptionsKey
        )

        if (selectedOption) {
            hasAnswer.value = true
            selectedAnswer.value = selectedOption.value
        }
    }
})

const onOptionClick = (option) => {
    if (option.key === 'yes' && props.item.link) {
        showCalendly.value = true
        calendlyFrameId.value = `calendly-frame-${props.item.param}`
        hasAnswer.value = true
        selectedAnswer.value = option.value
        nextTick(() => {
            loadCalendlyFrame(props.item.link, calendlyFrameId.value)
        })
    } else {
        hasAnswer.value = true
        selectedAnswer.value = option.value
        const newValue = { [props.item.param]: option.key }
        emit('callNext', newValue)
    }
}

const loadCalendlyFrame = (link: string | undefined, elementId: string) => {
    if (!hasCalendly(props.surveySpec)) {
        return
    }

    const calendlyFrame = document.getElementById(elementId)

    if (calendlyFrame) {
        initInlineWidget(link + '?hide_event_type_details=1', elementId)
        currentCalendlyFrame.value = calendlyFrame
        handleCalendlyMessages()
    }
}

const handleCalendlyMessages = () => {
    window.addEventListener('message', (e) => {
        if (isCalendlyEvent(e)) {
            if (currentCalendlyFrame.value) {
                currentCalendlyFrame.value.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                })
                const event = e.data.event.substring(9)
                if (calendlyEventWindowSizes[event] !== undefined) {
                    currentCalendlyFrame.value.style.height =
                        calendlyEventWindowSizes[event]
                }
                if (e.data.event === 'calendly.event_scheduled') {
                    emit('callNext')
                }
            }
        }
    })
}

return (_ctx: any,_cache: any) => {
  return (!hasAnswer.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item.options, (option) => {
          return (_openBlock(), _createElementBlock("button", {
            key: option.key,
            class: "survey-receive-options--item",
            onClick: ($event: any) => (onOptionClick(option))
          }, _toDisplayString(option.value), 9, _hoisted_2))
        }), 128)),
        (showCalendly.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: calendlyFrameId.value,
              class: "calendly-frame"
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("span", null, _toDisplayString(selectedAnswer.value), 1)
      ]))
}
}

})